$(() => {
  // 头部菜单
  (() => {
    let scrollTop = 0;
    let scrollT;
    function showNav() {
      $('.header').removeClass('hide-header');
    }

    $(window).scroll(() => {
      scrollT && clearTimeout(scrollT);
      scrollT = setTimeout(() => {
        const t = $(this).scrollTop();
        if (t > scrollTop) {
          $('.sub-menu').hide();
        }
        scrollTop = t;
      }, 500);
    });
  })();

  // 案例过滤
  (() => {
    $('.filter .more a').on('click', function() {
      const item = $(this).closest('.filter-item');
      const btn = $(this).find('i');
      if (item.hasClass('filter-item-open')) {
        item.removeClass('filter-item-open');
        btn.removeClass().addClass('icons icons-down');
      } else {
        item.addClass('filter-item-open');
        btn.removeClass().addClass('icons icons-up');
      }
    });
  })();

  // 顶部菜单
  (() => {
    var menuTime;
    function hideMenu() {
      menuTime && clearTimeout(menuTime);
      menuTime = setTimeout(() => {
        $('.sub-menu').hide();
      }, 1000);
    }

    $('.menu a').hover(function () {
      menuTime && clearTimeout(menuTime);
      $('.sub-menu').not($(this).closest('.sub-menu')).hide();
      $(this).siblings('.sub-menu').show();
    }, hideMenu);
    $('.sub-menu').hover(() => {
      menuTime && clearTimeout(menuTime);
    }, hideMenu);
  })();

  // 百度地图-底部公共
  (() => {
    var map = new BMap.Map("b-map");
    var point = new BMap.Point(119.303934,26.092508);
    var top_left_control = new BMap.ScaleControl({anchor: BMAP_ANCHOR_TOP_LEFT});// 左上角，添加比例尺
    var top_left_navigation = new BMap.NavigationControl();  //左上角，添加默认缩放平移控件

    map.centerAndZoom(point, 20);
    var marker = new BMap.Marker(new BMap.Point(119.303934,26.092508)); // 创建点
    map.addOverlay(marker);
    map.addControl(top_left_control);
    map.addControl(top_left_navigation);
  })();

  // 百度地图-联系我们
  (() => {
    if ($('#b-map2').length > 0) {
      var map = new BMap.Map("b-map2");
      var point = new BMap.Point(119.303934,26.092508);
      var top_left_control = new BMap.ScaleControl({anchor: BMAP_ANCHOR_TOP_LEFT});// 左上角，添加比例尺
      var top_left_navigation = new BMap.NavigationControl();  //左上角，添加默认缩放平移控件
      map.centerAndZoom(point, 20);
      var marker = new BMap.Marker(new BMap.Point(119.303934,26.092508)); // 创建点
      map.addOverlay(marker);
      map.addControl(top_left_control);
      map.addControl(top_left_navigation);
    }
  })();

  // 侧边栏工具条
  (() => {
    let toolsTime;
    const hide = () => {
      toolsTime && clearTimeout(toolsTime);
      toolsTime = setTimeout(() => {
        $('.tools-form').hide();
        $('.tools-hotline').hide();
      }, 1000);
    };

    $('.tools a').hover(function() {
      toolsTime && clearTimeout(toolsTime);
      const type = $(this).attr('data-type');
      $('#tools-form').data('type', type);
      $('#tools-form .msg').hide();
      $('#tools-form button').removeAttr('disabled');
      if (['online', 'design', 'visit'].includes(type)) {
        switch(type) {
          case 'online':
            $('.tools-form h4').html('在线咨询');
            $('.tools-form button').html('马上咨询');
            break;
          case 'design':
            $('.tools-form h4').html('预约设计师');
            $('.tools-form button').html('预约设计师');
            break;
          case 'visit':
            $('.tools-form h4').html('预约参观工地');
            $('.tools-form button').html('预约参观');
            break;
        }
        $('.tools-form').show();
        $('.tools-hotline').hide();
      } else if (type === 'hotline') {
        $('.tools-form').hide();
        $('.tools-hotline').show();
      } else {
        hide();
      }
    }, hide);
    $('.tools-form').hover(() => {
      toolsTime && clearTimeout(toolsTime);
    }, hide);
    $('.tools-hotline').hover(() => {
      toolsTime && clearTimeout(toolsTime);
    }, hide);

    $('.tools a[data-type="top"]').on('click', () => {
      $('body,html').animate({
        scrollTop: 0
      }, 500);
      return false;
    });

    $('#tools-form').on('submit', () => {
      const type = $('#tools-form').data('type');
      const url = $('#tools-form').attr('action');
      const name = $.trim($('#tools-form input[name="name"]').val());
      const tel = $.trim($('#tools-form input[name="tel"]').val());

      if (name === '') {
        $('#tools-form .msg').html('请输入姓名').show();
        return;
      }
      if (tel === '') {
        $('#tools-form .msg').html('请输入联系电话').show();
        return;
      }
      if(!(/^1\d{10}$/.test(tel))){
        $('#tools-form .msg').html('手机号码有误，请重填').show();
        return false;
      }
      $('#tools-form .msg').html('请稍后...').show();
      $('#tools-form button').attr('disabled', 'disabled');

      $.ajax({
        url,
        type: 'post',
        data: {
          type,
          name,
          tel
        },
        success: res => {
          $('#tools-form button').removeAttr('disabled');
          $('#tools-form .msg').html(res.msg).show();
        },
        error: () => {
          $('#tools-form button').removeAttr('disabled');
          $('#tools-form .msg').html('提交失败，请重试！').show();
        }
      });
      return false;
    });
  })();
});